function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Caret Right Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0.646446609,1.35355339 C0.451184464,1.15829124 0.451184464,0.841708755 0.646446609,0.646446609 C0.841708755,0.451184464 1.15829124,0.451184464 1.35355339,0.646446609 L6.35355339,5.64644661 C6.54881554,5.84170876 6.54881554,6.15829124 6.35355339,6.35355339 L1.35355339,11.3535534 C1.15829124,11.5488155 0.841708755,11.5488155 0.646446609,11.3535534 C0.451184464,11.1582912 0.451184464,10.8417088 0.646446609,10.6464466 L5.29289322,6 L0.646446609,1.35355339 Z",
  id: "caret-right-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "caret-right-Icon/Global/Caret/Right",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "caret-right-Swatches/DarkGreen",
  transform: "translate(8.000000, 6.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "caret-right-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#caret-right-path-1"
})));

var SvgCaretRight = function SvgCaretRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCaretRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/caret-right.14660fcd.svg";
export { ForwardRef as ReactComponent };